(function () {
	if (window.__partifyBackInStockInitialized) return;
	window.__partifyBackInStockInitialized = true;

	var ROOT_SELECTOR = "[data-partify-back-in-stock]";
	var OPEN_SELECTOR = "[data-partify-bis-open]";
	var CLOSE_SELECTOR = "[data-partify-bis-close]";
	var MODAL_SELECTOR = "[data-partify-bis-modal]";
	var SUBMIT_SELECTOR = "[data-partify-bis-submit]";
	var EMAIL_SELECTOR = '.partify-bis-modal__input[type="email"]';

	function closest(element, selector) {
		return element && element.closest ? element.closest(selector) : null;
	}

	function getParts(root) {
		return {
			modal: root && root.querySelector(MODAL_SELECTOR),
			trigger: root && root.querySelector(OPEN_SELECTOR),
			email: root && root.querySelector(EMAIL_SELECTOR),
			status: root && root.querySelector("[data-partify-bis-status]"),
			submit: root && root.querySelector(SUBMIT_SELECTOR),
			form: root && root.querySelector("[data-partify-bis-form]"),
		};
	}

	function openModal(root) {
		var parts = getParts(root);
		if (!parts.modal || !parts.email) return;

		parts.modal.hidden = false;
		document.body.classList.add("partify-bis-modal-open");
		window.setTimeout(function () {
			parts.email.focus();
		}, 0);
	}

	function closeModal(root) {
		var parts = getParts(root);
		if (!parts.modal) return;

		parts.modal.hidden = true;
		document.body.classList.remove("partify-bis-modal-open");
		if (parts.trigger) parts.trigger.focus();
	}

	function setStatus(parts, message, state) {
		parts.status.textContent = message;
		parts.status.className = "partify-bis-modal__status" + (state ? " is-" + state : "");
	}

	function subscribe(root) {
		var parts = getParts(root);
		var variantId = root && root.getAttribute("data-variant-id");
		if (!parts.email || !parts.status || !parts.submit || !parts.form || !variantId) return;

		if (!parts.email.checkValidity()) {
			setStatus(parts, "Enter a valid email address.", "error");
			parts.email.focus();
			return;
		}

		setStatus(parts, "", "");
		parts.submit.disabled = true;
		parts.submit.textContent = "Submitting...";

		var payload = {
			data: {
				type: "back-in-stock-subscription",
				attributes: {
					profile: {
						data: {
							type: "profile",
							attributes: { email: parts.email.value.trim() },
						},
					},
					channels: ["EMAIL"],
				},
				relationships: {
					variant: {
						data: {
							type: "catalog-variant",
							id: "$shopify:::$default:::" + variantId,
						},
					},
				},
			},
		};

		fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VT4WTY", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				revision: "2025-01-15",
			},
			body: JSON.stringify(payload),
		})
			.then(function (response) {
				if (!response.ok) throw new Error("Subscription failed");

				parts.form.classList.add("is-complete");
				parts.email.disabled = true;
				parts.submit.hidden = true;
				setStatus(parts, "You're in! We'll let you know when it's back.", "success");
			})
			.catch(function () {
				parts.submit.disabled = false;
				parts.submit.textContent = "Notify me when available";
				setStatus(parts, "We couldn't save your request. Please try again.", "error");
			});
	}

	document.addEventListener(
		"click",
		function (event) {
			var target = event.target;
			var openButton = closest(target, OPEN_SELECTOR);
			if (openButton) {
				event.preventDefault();
				openModal(closest(openButton, ROOT_SELECTOR));
				return;
			}

			var closeButton = closest(target, CLOSE_SELECTOR);
			if (closeButton) {
				event.preventDefault();
				closeModal(closest(closeButton, ROOT_SELECTOR));
				return;
			}

			var submitButton = closest(target, SUBMIT_SELECTOR);
			if (submitButton) {
				event.preventDefault();
				subscribe(closest(submitButton, ROOT_SELECTOR));
			}
		},
		true,
	);

	document.addEventListener(
		"keydown",
		function (event) {
			var target = event.target;
			var root = closest(target, ROOT_SELECTOR);
			if (event.key === "Escape" && root) {
				var modal = root.querySelector(MODAL_SELECTOR);
				if (modal && !modal.hidden) closeModal(root);
				return;
			}

			if (event.key === "Enter" && closest(target, EMAIL_SELECTOR) && root) {
				event.preventDefault();
				subscribe(root);
			}
		},
		true,
	);
})();
